import { Component, OnInit, Input } from '@angular/core';
import { Listing } from '../../../classes/listing';
import { LoginSource } from '../../../classes/enums';
import { UserService } from '../../../services/user.service';
import { Router } from '@angular/router';
import { CredentialsService } from '../../../services/credentials.service';
import { HasSubscriptions } from '../../../components/has-subscriptions';
import {CurrencyPipe} from '@angular/common';
import {HomeEstimatorService} from "../../../services/home-estimator.service";
import {SCREEN_SIZE} from "../../../classes/enums";
import {debounceTime} from "rxjs/operators";
import {CommunicationService} from "../../../services/communication.service";
import { AllowedHveCities } from '../../../app-config.constants';

@Component({
  selector: 'app-estimated-value',
  templateUrl: './estimated-value.component.html',
  styleUrls: ['./estimated-value.component.scss']
})

export class EstimatedValueComponent extends HasSubscriptions implements OnInit {

  @Input() listing: Listing;
  estimateRangeHigh: string;
  estimateRangeLow: string;
  retrievingEstimate: boolean = true;
  screenSize: number;
  isAllowed: boolean;
  isAuthenticated: boolean;

  constructor(private homeEstimatorService: HomeEstimatorService,
    private userService: UserService,
    private router: Router,
    private communicationService: CommunicationService,
    private credentialsService: CredentialsService,
    private currencyPipe: CurrencyPipe)
  {
    super();
  }

  get isMobile() {
    return this.screenSize == SCREEN_SIZE.MOBILE_ONLY;
  }

  ngOnInit() {
    this.addSub(this.communicationService.screenSize.pipe(debounceTime(50)).subscribe((screenSize) => {
      this.screenSize = screenSize;
    }));

    this.isAllowed = AllowedHveCities.includes(this.listing.city.toLowerCase());

    if ( this.listing.isOffMarket && !this.userService.isGoogleBot()) {
      this.addSub(this.credentialsService.isLoggedIn.subscribe((isAuthenticated) => {
        this.isAuthenticated = isAuthenticated;
        if (isAuthenticated || this.isAllowed) {
          this.homeEstimatorService.getOffMarketHomeEstimate(this.listing.id).then(response =>
            [this.estimateRangeHigh, this.estimateRangeLow, this.retrievingEstimate] = [this.currencyPipe.transform(response.estimateRangeHigh, 'CAD', 'symbol-narrow', '1.0-0'), this.currencyPipe.transform(response.estimateRangeLow, 'CAD', 'symbol-narrow', '1.0-0'), false]);
        }
      }));
    }
  }
  loginToView() {
    this.router.navigate(['/', { outlets: { popup: [ 'register-login', LoginSource.HomeEstimator ] } }]);
  }
}
